export function getPathWithoutTag(fullPath: string, tag: string): string {
  const cleanedPath = fullPath.replace(/\/$/, '');
  const cleanedTag = tag.replace(/\/$/, '');

  // Удаляем /tags/{tag}
  const tagPattern = new RegExp(`/tags/${cleanedTag}$`);
  if (tagPattern.test(cleanedPath)) {
    return cleanedPath.replace(tagPattern, '/') || '/';
  }

  // Удаляем /{tag} в конце
  const endPattern = new RegExp(`/${cleanedTag}$`);
  if (endPattern.test(cleanedPath)) {
    return cleanedPath.replace(endPattern, '/') || '/';
  }

  return fullPath;
}
